/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "f46332dc41dd505a68a687ef4fa23701227e0c23";
